module.exports = __webpack_public_path__ + "img/live-subscribe.e103927f.svg";